import React from "react";
import SearchIcon from "@material-ui/icons/Search";
import { InputAdornment } from "@material-ui/core";
import { CustomTextField } from "containers/gstr2a2bNewEnhancement/Utility/utility";
import downloadWhite from "images/downloadWhite.svg";
import { Button } from "@material-ui/core";
import "../../../../style.css";
import Table from "./Table";
import { useSelector } from "react-redux";

const NotInGSTN = (props) => {
   const { selectedNotInGstn,selectedRowNotInGstn,searchStr } = useSelector(
    (store) => store.gstr2a2bNewRecoReducer
  );
  return (
    <>
      <div style={{ display: "flex", justifyContent: "flex-start" }}>
        <div style={{ width: "35%", marginTop: "0.3em" }}>
          <CustomTextField
            style={{ backgroundColor: "white" }}
            placeholder="Search"
            className="custom-search-field"
            variant="outlined"
            size="small"
              value={searchStr}
            onChange={props.handleInputChange}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </div>
        <Button
          onClick={() => props.handleDownload("NotInGstn")}
          type="submit"
          variant="contained"
          color="primary"
          style={{
            backgroundColor: "#4f2d7f",
            color: "white",
            marginTop: "0.8em",
            marginLeft: "1em",
            height: "32px",
            fontSize: "12px",
            textTransform: "capitalize",
          }}
        >
          <img
            src={downloadWhite}
            alt="Download"
            style={{
              width: "30px",
              height: "20px",
              paddingBottom: "3px",
            }}
          />
        </Button>
        <Button
          onClick={props.handleOpen}
          type="submit"
          variant="contained"
          color="primary"
          style={{
            backgroundColor: "#4f2d7f",
            color: "white",
            marginTop: "0.8em",
            marginLeft: "1em",
            height: "32px",
            fontSize: "12px",
            textTransform: "capitalize",
            paddingLeft: "1.5em",
            paddingRight: "1.5em",
          }}
        >
          Filter
        </Button>
        <Button
         onClick={()=>props.handleAcceptPrGstn(selectedNotInGstn,'PR',selectedRowNotInGstn)}
          type="submit"
          variant="contained"
          color="primary"
          style={{
            backgroundColor: "#4f2d7f",
            color: "white",
            marginTop: "0.8em",
            marginLeft: "1em",
            height: "32px",
            fontSize: "12px",
            textTransform: "capitalize",
          }}
        >
          Accept PR
        </Button>

        <Button
          onClick={()=>props.handlePending(selectedNotInGstn,'PENDING',selectedRowNotInGstn)}
          type="submit"
          variant="contained"
          color="primary"
          style={{
            backgroundColor: "#4f2d7f",
            color: "white",
            marginTop: "0.8em",
            marginLeft: "1em",
            height: "32px",
            fontSize: "12px",
            textTransform: "capitalize",
          }}
        >
          Pending
        </Button>
      </div>
      <Table handlePageClick={props.handlePageClick} handleSubmit={props.handleSubmit}/>
    </>
  );
};

export default NotInGSTN;
